import { ApiClient } from "@/services/apiClient";
import { type UserRating } from "@/services/user/rating";

export const rateUser = async (userId: number, rating: number): Promise<UserRating> => {
  const url = "api/user/collector/rating";
  const params = { userId, rating };
  return ApiClient.putPublic<UserRating>(url, {}, params).then((response) => response.data);
};

export const fetchUserRating = async (userId: number): Promise<UserRating> => {
  const url = "api-public/user/collector/rating";
  const params = { userId };
  return ApiClient.getPublic<UserRating>(url, params).then((response) => response.data);
};
